function getPlatformFromUserAgent(senderUserAgent: string = ''): string | undefined {
  if (senderUserAgent.includes('Android')) {
    return 'Android';
  }
  if (senderUserAgent.includes('iPhone') || senderUserAgent.includes('iPad')) {
    return 'iOS';
  }
  return undefined;
}

const androidProfile = 'talpa_chromecast_mp4_ovp_android';
const iosProfile = 'talpa_chromecast_mp4_ovp_ios';

const appPlayerChannel = 'kijk2 app';

export default function getAppConfiguration(
  adTagUrl: string = '',
  senderUserAgent: string = '',
): { playerChannel: string; platform?: string } | null {
  const platform = getPlatformFromUserAgent(senderUserAgent);

  if (!adTagUrl) {
    return { playerChannel: appPlayerChannel, platform };
  }

  if (adTagUrl.includes(androidProfile)) {
    return { playerChannel: appPlayerChannel, platform: 'Android' };
  }

  if (adTagUrl.includes(iosProfile)) {
    return { playerChannel: appPlayerChannel, platform: 'iOS' };
  }

  return null;
}
